import $ from "jquery";

$(function () {
  $(".more-switch span").on("click", function () {
    var elem = $(this);

    if (elem.hasClass("js-opend")) {
      $(this).parent().prev(".js-hide").slideUp();
      $(this).removeClass("js-opend");
      $(this).text("すべて表示");
    } else {
      $(this).parent().prev(".js-hide").slideDown();
      $(this).addClass("js-opend");
      $(this).text("おりたたむ");
    }
  });
});
